import { useSuspenseQuery } from '@tanstack/react-query';
import { getInsuranceProviderOptions } from '@generated';
import { PageSection } from '~/shared/section/PageSection';
import { BuildingIcon } from 'lucide-react';
import { OverviewTab } from './tabs/OverviewTab';
import { ContactsTab } from './tabs/ContactsTab';
import { useRequiredParam } from '~/shared/routing/useRequiredParam';
import { QueryParamTabs } from '~/shared/components/tabs/QueryParamTabs';
import { Tabs } from '~/shared/components/tabs/Tabs';
import { PageLayout } from '~/shared/PageLayout';

const views = [
	{ label: 'Overview', value: 'overview' },
	{ label: 'Contacts', value: 'contacts' }
];

export function InsuranceProviderDetail() {
	const id = useRequiredParam('id');
	const { data: provider } = useSuspenseQuery(getInsuranceProviderOptions(id));

	return (
		<PageLayout pageHeader={{ title: 'Insurance Provider Library' }}>
			<PageSection title={provider.name} description={`${provider.insuranceType} - ${provider.payorType}`} TitleIcon={BuildingIcon}>
				<QueryParamTabs defaultTab={views[0].value} className="gap-0">
					<Tabs.TabList aria-label="Insurance Provider Sections">
						{views.map(view => (
							<Tabs.Tab id={view.value} key={view.value}>
								{view.label}
							</Tabs.Tab>
						))}
					</Tabs.TabList>
					<Tabs.TabPanel id="overview" className="p-4">
						<OverviewTab provider={provider} />
					</Tabs.TabPanel>
					<Tabs.TabPanel id="contacts" className="p-4">
						<ContactsTab provider={provider} />
					</Tabs.TabPanel>
				</QueryParamTabs>
			</PageSection>
		</PageLayout>
	);
}
